<template>
  <div class="header flex flex-row">
    <div class="h-Qrcode basis-1/4" @click="showMenuHandler">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M15 19l-7-7 7-7"
        />
      </svg>
    </div>
    <h2 class="subject basis-1/2">
      {{ title }}
    </h2>
    <div class="hmenu basis-1/4" v-if="hasVerifi">
      <img
        @click="nextHandler"
        style="filter: brightness(0.05) drop-shadow(0px 3px 0px white)"
        src="@/assets/icons/icons8-done.svg"
      />
    </div>
    <div class="hmenu basis-1/4" v-else></div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    title: String,
    hasVerifi: Boolean,
  },
  data() {
    return {
      showMenu: false,
    };
  },
  methods: {
    showMenuHandler() {
      this.$emit("back");
      console.log("gooback");
    },
    nextHandler() {
      this.$emit("next");
    },
  },
};
</script>

<style></style>
